export enum AddressOutput {
    FullAddress,
    NotPublished,
    PartialAddress,
    StreetAndCity
}